  <div class="company-header">
  <div class="company-card">
    <div class="company-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>

    <div class="cluster-data">
      <div class="cluster-card-header">
        <span class="cluster-name">{{ cluster.getName() }}</span>
      </div>

      <div class="cluster-data-container">
        <div class="data-container">
          <span class="data-value"><strong>Data de criação: </strong>{{ cluster.getCreatedDate() }}</span>
        </div>
        <div class="data-container">
          <span class="data-value"><strong>Produtos: </strong>{{ dataSource.data.length }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="table-header-cluster">
  <div class="search-container" pattern="[0-9]+">
    <div>
      <span><b>Pesquisar por EAN</b></span>
      <input [(ngModel)]="ean" type="text" autofocus (keyup.enter)="searchProductsByEan()" />
    </div>

    <div class="icon-container" (click)="searchProductsByEan()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>

  <div>
    <button class="add-cluster-product" mat-flat-button (click)="addBatchProduct()">ADICIONAR EM LOTE</button>
  </div>
  <div>
    <button class="add-cluster-product" mat-flat-button (click)="addProduct()">ADICIONAR PRODUTO</button>
  </div>
</div>

<div class="control">
  <p class="register-count" *ngIf="!hasClusterProducts()">Não foram encontrados resultados.</p>
  <p class="register-count" *ngIf="hasClusterProducts()">
    Foram encontrados
    {{ dataSource.data.length }} registros
  </p>
</div>

<div class="cluster-list-container">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="ean">
        <th mat-header-cell *matHeaderCellDef>EAN</th>
        <td mat-cell *matCellDef="let item">{{ item.getEan() }}</td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let item">{{ item.getName() }}</td>
      </ng-container>

      <ng-container matColumnDef="deleteProduct">
        <th class="align-center" mat-header-cell *matHeaderCellDef>Remover</th>
        <td class="align-center" mat-cell *matCellDef="let item">
          <mat-icon class="delete-icon" (click)="onDeleteProduct(item.getEan())"> delete </mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="totalCount" [pageIndex]="pageIndex - 1" [pageSizeOptions]="[10, 20, 30]" (page)="changePage($event)"></mat-paginator>
    <div class="btn-container">
      <button mat-flat-button class="back-btn" (click)="backToClusters()"><mat-icon aria-hidden="false">west</mat-icon>VOLTAR</button>
      <button mat-flat-button class="register-btn" (click)="exportClusterList(cluster)">Exportar lista</button>
    </div>
  </div>

</div>
